module.exports = __webpack_public_path__ + "media/bootstrap-icons/keyboard-fill-fe454c94.svg";